import React, { useEffect, useState } from "react";
import Category from "../Category/Category";
import style from "./Form.module.css";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import {
  resetAllBudget,
  updateCategoricalBudget,
  updateEdit,
  updateMonthlyBudget,
  updateUserName,
} from "../../redux/userSlice";
import { resetAllExpense } from "../../redux/expenseSlice";
import { removeAllTransactions } from "../../redux/transactionSlice";

const Form = () => {
  const [formData, setFormData] = useState({
    userName: "",
    monthlyBudget: "",
    edit: false,
    categoricalBudget: {
      food: "",
      travel: "",
      entertainment: "",
      others: "",
    },
  });

  // const reduxFormData = useSelector((state) => state.user);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (["food", "travel", "entertainment"].includes(name)) {
      setFormData((prev) => ({
        ...prev,
        categoricalBudget: {
          ...prev.categoricalBudget,
          [name]: Number(value),
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: isNaN(Number(value)) ? value : Number(value),
      }));
    }
  };

  const handleValidation = () => {
    const { monthlyBudget, categoricalBudget } = formData;
    const { food, travel, entertainment } = categoricalBudget;

    if (Number(monthlyBudget) <= 0) {
      enqueueSnackbar("Monthly budget should be greater than 0", {
        variant: "warning",
      });
      return false;
    }
    const total = Number(food) + Number(travel) + Number(entertainment);
    if (total > Number(monthlyBudget)) {
      enqueueSnackbar(
        "Total Categorical budget should not exceed monthly budget",
        { variant: "warning" }
      );
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!handleValidation()) return;

    const { monthlyBudget, categoricalBudget, userName } = formData;
    const { food, travel, entertainment } = categoricalBudget;
    const othersBudget =
      Number(monthlyBudget) -
      (Number(food) + Number(travel) + Number(entertainment));

    // Compute the updated categorical budget locally
    const newCategoricalBudget = {
      ...categoricalBudget,
      others: othersBudget,
    };

    // Compute the updated form data locally
    const updatedFormData = {
      ...formData,
      edit: true,
      categoricalBudget: newCategoricalBudget,
    };

    // Update the local state and Redux
    setFormData(updatedFormData);
    dispatch(updateUserName(userName));
    dispatch(updateMonthlyBudget(monthlyBudget));
    dispatch(updateCategoricalBudget(newCategoricalBudget));
    dispatch(updateEdit(true));

    // Save the updated form data to local storage
    localStorage.setItem("formData", JSON.stringify(updatedFormData));

    navigate("tracker");
  };

  const handleReset = () => {
    if (!window.confirm("This will delete all previous transaction")) {
      return;
    }

    dispatch(resetAllBudget());
    dispatch(resetAllExpense());
    dispatch(removeAllTransactions());
    setFormData({
      userName: "",
      monthlyBudget: "",
      edit: false,
      categoricalBudget: {
        food: "",
        travel: "",
        entertainment: "",
        others: "",
      },
    });
    // Optionally clear local storage as well
    localStorage.removeItem("formData");
  };

  useEffect(() => {
    const storedData = localStorage.getItem("formData");
    if (storedData) {
      setFormData(JSON.parse(storedData));
    }
  }, []);

  const { userName, monthlyBudget, categoricalBudget } = formData;
  return (
    <form onSubmit={handleSubmit} name="landing-page-form">
      <div>
        <div>
          <label htmlFor="name">Enter Your Name:</label>
          <input
            type="text"
            name="userName"
            id="name"
            value={userName}
            onChange={handleChange}
          />
        </div>

        <div>
          <label htmlFor="budget">Enter your monthly budget:</label>
          <input
            type="number"
            name="monthlyBudget"
            id="budget"
            value={monthlyBudget}
            onChange={handleChange}
          />
        </div>

        <p>Fill your monthly categoricaly budget</p>
        <div className={style.category}>
          <Category
            handleChange={handleChange}
            categoricalBudget={categoricalBudget}
          />
        </div>
      </div>
      {formData.edit ? (
        <div>
          <button type="button"  onClick={handleSubmit}>
            Update Budget
          </button>

          <button type="button" id="clear" onClick={handleReset}>
            Start New Tracker
          </button>
          <button
            type="button"
            id="go-back"
            onClick={() => navigate("tracker")}
          >
            Go Back
          </button>
        </div>
      ) : (
        <button type="submit">Submit</button>
      )}
    </form>
  );
};

export default Form;
